// extracted by mini-css-extract-plugin
export default {"scrim":"Container_scrim__okENy","widget":"Container_widget__uKnk+","body":"Container_body__dQQEi"};